// @ts-nocheck
import espLogo from '@/static/images/esp-logo.png';
import sageLogo from '@/static/images/sage-logo.png';
import oneSourceLogo from '@/static/images/onesource-logo.png';

export interface CredentialField {
  name: string;
  label: string;
  placeholder: string;
  type?: string;
}

export interface CatalogProviderConfig {
  key: string;
  label: string;
  logo: string;
  credentialFields: CredentialField[];
  filterSections?: { key: string; label: string; type: 'checkbox' | 'expand' }[];
}

const PROVIDER_CONFIGS: Record<string, CatalogProviderConfig> = {
  esp: {
    key: 'esp',
    label: 'ESP',
    logo: espLogo,
    credentialFields: [
      { name: 'username', label: 'User', placeholder: 'Enter User' },
      { name: 'asiNumber', label: 'ASI Number', placeholder: 'Enter ASI Number' },
      { name: 'loginId', label: 'Email ID', placeholder: 'Enter Email ID' },
      { name: 'password', label: 'Password', placeholder: 'Enter Password', type: 'password' },
    ],
    filterSections: [
      { key: 'categories', label: 'Categories', type: 'expand' },
      { key: 'colors', label: 'Colors', type: 'expand' },
      { key: 'sizes', label: 'Sizes', type: 'expand' },
      { key: 'suppliers', label: 'Suppliers', type: 'expand' },
    ],
    hidden: false,
  },
  sage: {
    key: 'sage',
    label: 'SAGE',
    logo: sageLogo,
    credentialFields: [
      { name: 'username', label: 'User', placeholder: 'Enter User' },
      { name: 'asiNumber', label: 'Account ID', placeholder: 'Enter ASI Number' },
      { name: 'loginId', label: 'Login ID', placeholder: 'Enter Username' },
      { name: 'password', label: 'API Key', placeholder: 'Enter Password', type: 'password' },
    ],
    filterSections: [
      { key: 'itemNumber', label: 'Item Number', type: 'checkbox' },
      { key: 'supplierId', label: 'Supplier ID', type: 'checkbox' },
      { key: 'categories', label: 'Categories', type: 'expand' },
    ],
    hidden: true,
  },
  onesource: {
    key: 'onesource',
    label: 'OneSource',
    logo: oneSourceLogo,
    credentialFields: [
      { name: 'username', label: 'User', placeholder: 'Enter User' },
      { name: 'asiNumber', label: 'Account ID', placeholder: 'Enter ASI Number' },
      { name: 'loginId', label: 'Login ID', placeholder: 'Enter Username' },
      { name: 'password', label: 'API Key', placeholder: 'Enter Password', type: 'password' },
    ],
    filterSections: [
      { key: 'categories', label: 'Categories', type: 'expand' },
    ],
    hidden: true,
  },
  products: {
    key: 'products',
    label: 'Products Catalog',
    logo: null,
    credentialFields: [],
    filterSections: [],
    hidden: false,
  },
};

export const ALL_PROVIDERS = Object.values(PROVIDER_CONFIGS);

export function useCatalogProviderConfig(providerKey: string): CatalogProviderConfig {
  return PROVIDER_CONFIGS[providerKey] || PROVIDER_CONFIGS['products'];
}
